import type { HoldingsBreakdown } from 'venn-api';
import { type CustomBlockTypeEnum, isHoldingsFixedIncomeBlock } from 'venn-utils';

const EPSILON = 0.000001;

/**
 * Checks if a holdings breakdown has valid coverage (fixed income)
 *
 * @param breakdown - The holdings breakdown to check.
 * @returns `true` if the percentage covered is greater than EPSILON, otherwise `false`.
 */
export const hasValidCoverage = (breakdown: HoldingsBreakdown): boolean => {
  const coverage = breakdown.percentageCovered;
  return coverage > EPSILON;
};

/**
 * Checks if a holdings breakdown should be included based on the block type and coverage
 *
 * @param breakdown - The holdings breakdown to check.
 * @param blockType - The type of block.
 * @returns `true` if the breakdown should be included, otherwise `false`.
 */
export const shouldIncludeBreakdown = (breakdown: HoldingsBreakdown, blockType: CustomBlockTypeEnum): boolean => {
  // Only filter by coverage for holding blocks that have long rescaled values
  if (isHoldingsFixedIncomeBlock(blockType)) {
    return hasValidCoverage(breakdown);
  }

  return true;
};
